import { render, staticRenderFns } from "./ShareTechpackDialog.vue?vue&type=template&id=192f2db3"
import script from "./ShareTechpackDialog.vue?vue&type=script&lang=ts"
export * from "./ShareTechpackDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShareTechpackDialog.vue?vue&type=style&index=0&id=192f2db3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports